/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus } from './GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus';
import {
    GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusFromJSON,
    GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusFromJSONTyped,
    GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusToJSON,
} from './GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus';

/**
 * 設定情報
 * @export
 * @interface GetEnterpriseSystemSettings200ResponseSettings
 */
export interface GetEnterpriseSystemSettings200ResponseSettings {
    /**
     * メンテナンスステータス 1:正常 2:メッセージのみ 3:停止
     * @type {number}
     * @memberof GetEnterpriseSystemSettings200ResponseSettings
     */
    maintenanceStatus: number;
    /**
     * 
     * @type {GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus}
     * @memberof GetEnterpriseSystemSettings200ResponseSettings
     */
    displayStatus?: GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus;
    /**
     * 表示タイトル
     * @type {string}
     * @memberof GetEnterpriseSystemSettings200ResponseSettings
     */
    title?: string;
    /**
     * 表示本文
     * @type {string}
     * @memberof GetEnterpriseSystemSettings200ResponseSettings
     */
    text?: string;
    /**
     * 表示期間
     * @type {string}
     * @memberof GetEnterpriseSystemSettings200ResponseSettings
     */
    period?: string;
}

/**
 * Check if a given object implements the GetEnterpriseSystemSettings200ResponseSettings interface.
 */
export function instanceOfGetEnterpriseSystemSettings200ResponseSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "maintenanceStatus" in value;

    return isInstance;
}

export function GetEnterpriseSystemSettings200ResponseSettingsFromJSON(json: any): GetEnterpriseSystemSettings200ResponseSettings {
    return GetEnterpriseSystemSettings200ResponseSettingsFromJSONTyped(json, false);
}

export function GetEnterpriseSystemSettings200ResponseSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEnterpriseSystemSettings200ResponseSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maintenanceStatus': json['maintenance_status'],
        'displayStatus': !exists(json, 'display_status') ? undefined : GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusFromJSON(json['display_status']),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'period': !exists(json, 'period') ? undefined : json['period'],
    };
}

export function GetEnterpriseSystemSettings200ResponseSettingsToJSON(value?: GetEnterpriseSystemSettings200ResponseSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maintenance_status': value.maintenanceStatus,
        'display_status': GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusToJSON(value.displayStatus),
        'title': value.title,
        'text': value.text,
        'period': value.period,
    };
}

